import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

import type { ForwardRefRenderFunction, HTMLAttributes } from 'react';

export type InputFieldLabelProps = Omit<
  HTMLAttributes<HTMLLabelElement>,
  'className'
> & {
  asChild?: boolean;
};

const InputFieldLabelRenderFunction: ForwardRefRenderFunction<
  HTMLLabelElement,
  InputFieldLabelProps
> = ({ asChild, ...attrs }, ref) => {
  const Element = asChild ? Slot : 'label';

  return (
    <Element
      {...attrs}
      ref={ref}
      className="label-md text-marine-high-emphasis"
    />
  );
};

export const InputFieldLabel = forwardRef<
  HTMLLabelElement,
  InputFieldLabelProps
>(InputFieldLabelRenderFunction);
